module.exports = __webpack_public_path__ + "assets/HKNova-SemiBold.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-SemiBold.ttf
// module id = 130
// module chunks = 0